import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'localTime'
})
export class LocalTimePipe implements PipeTransform {
  constructor(private datePipe: DatePipe) {}

  transform(
    value: string | Date | null | undefined,
    format: string = 'dd/MM/yyyy HH:mm' // Default format, adjust as needed
  ): string | null {
    if (value === null || value === undefined || value === '') {
      return null;
    }

    let dateInput: string | Date = value;

    // If the input is a string and doesn't obviously have timezone info (like ending in 'Z' or having a +/- offset),
    // and it matches a common ISO-like structure, assume it's UTC and append 'Z'.
    // This helps DatePipe correctly interpret it as UTC.
    // YYYY-MM-DDTHH:MM:SS or YYYY-MM-DDTHH:MM:SS.sss
    if (
      typeof value === 'string' &&
      !value.endsWith('Z') &&
      !value.match(/[+-]\d{2}:\d{2}$/) &&
      value.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?$/)
    ) {
      dateInput = value + 'Z';
    }

    try {
      // Angular's DatePipe, when given a full ISO string with UTC offset (like those ending in 'Z')
      // or a JavaScript Date object (which is internally UTC ms since epoch),
      // will automatically format it to the user's local timezone by default.
      return this.datePipe.transform(dateInput, format);
    } catch (error) {
      console.error(
        'LocalTimePipe: Error transforming date:',
        error,
        'Original value:',
        value
      );
      // Fallback or handle error
      if (typeof value === 'string') return value; // Or an error indicator like 'Invalid Date'
      if (value instanceof Date) return value.toISOString(); // Or 'Invalid Date'
      return 'Invalid Date'; // Default fallback for other types or unhandled errors
    }
  }
}
